<template>
  <div data-component-group="business-form" data-component="notes">
    <slot name="beforeForm" />

    <Removables
      :items="notes"
      removable-class="elevation-1"
      :is-disabled="true"
      :on-remove="removeNote"
    >
      <template v-slot:item="scope" >
        <div class="w-100">
          <div v-html="scope.item.note" />
        </div>
      </template>
    </Removables>
  </div>
</template>

<script>
  import Removables from '../../lists/Removables';

  export default {
    components: {
      Removables,
    },
    props: {
      notes: {
        type: Array,
        required: true,
      },
    },
    methods: {
      removeNote() {},
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='business-form'] {
  &[data-component='notes'] {
    padding: 1.5rem;
    background-color: rgb(var(--v-theme-surface));

    .v-list--two-line .v-list-item {
      height: auto;
      align-items: flex-start;
      padding: 8px 16px;
      background-color: rgba(var(--v-theme-on-surface), 0.04);
    }

    [data-component='amount'] {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    [data-component='removables'] {
      padding: 0;
    }
  }
}
</style>
